import Resource from '@/api/resources/Resource'

class CaseCodificationServices extends Resource {
    async getCodifications(labId, caseId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/codifications`)
        return response.data
    }
    async createBatchCodifications(labId, caseId, codificationRequests) {
        const response = await this.axios.post(`/laboratories/${labId}/cases/${caseId}/codifications/createBatch`, codificationRequests)
        return response.data
    }
    async deleteBatchCodifications(labId, caseId, codificationIds) {
        const params = {
            entityIdentifiers: codificationIds.map(codification => codification.id)
        }
        const response = await this.axios.delete(`/laboratories/${labId}/cases/${caseId}/codifications/deleteBatch`, { data: params })
        return response.data
    }
    async updateBatchCodifications(labId, caseId, updateRequests) {
        const response = await this.axios.put(`/laboratories/${labId}/cases/${caseId}/codifications/updateBatch`, updateRequests)
        return response.data
    }
}

export default new CaseCodificationServices()
